// extracted by mini-css-extract-plugin
export var addToCartButton = "_lx-b";
export var arrowButtonContainer = "_lx-9";
export var arrowButtonIcon = "_lx-a";
export var carouselArrowButton = "_lx-6";
export var carouselElementContainer = "_lx-1";
export var left = "_lx-7";
export var productDisplayCarouselContainer = "_lx-0";
export var productTileContainer = "_lx-2";
export var productTileImage = "_lx-4";
export var productTileImageContainer = "_lx-3";
export var productTileTitle = "_lx-5";
export var right = "_lx-8";
export var sliderOverflow = "_lx-c";